<template>
  <div class="row">
    <div class="col-xl- col-lg-12">
      <div class="card card-default">
        <form-wizard
          title=""
          subtitle=""
          @on-complete="onComplete"
          stepSize="sm"
        >
          <tab-content
            title="Domain and Mailbox"
            :before-change="() => validateStep('zimbra-mail')"
          >
            <form novalidate data-vv-scope="domain-domain">
              <div class="row">
                <div class="col-xl-6">
                  <div
                    class="form-group"
                    :class="{
                      'has-error': errors.has('zimbra-mail.domain'),
                    }"
                  >
                    <label class="control-label">Domain *</label>
                    <v-select
                      :options="filledInSaleDefinition.selectableOptions.domain"
                      placeholder="Select Domain"
                      v-validate="'required'"
                      name="domain"
                      label="domainName"
                      valueProp="zimbraDomainNumber"
                      v-model="
                        filledInSaleDefinition.requiredObjs.mailbox
                          .zimbraDomainNumber
                      "
                    ></v-select>
                    <span
                      class="has-error"
                      v-if="errors.has('zimbra-mail.domain')"
                      >{{ errors.first("zimbra-mail.domain") }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-6">
                  <div
                    class="form-group"
                    :class="{
                      'has-error': errors.has('zimbra-mail.username'),
                    }"
                  >
                    <label class="control-label">Username *</label>
                    <input
                      type="text"
                      class="form-control"
                      name="username"
                      v-validate="'required'"
                      v-model="
                        filledInSaleDefinition.requiredObjs.mailbox.username
                      "
                    />
                    <span
                      class="has-error"
                      v-if="errors.has('zimbra-mail.username')"
                      >{{ errors.first("zimbra-mail.username") }}</span
                    >
                  </div>
                </div>
              </div>
            </form>
          </tab-content>
        </form-wizard>
      </div>
    </div>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

export default {
  components: {
    FormWizard,
    TabContent,
  },
  props: {
    emptySaleDefinition: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      filledInSaleDefinition: {
        requiredObjs: {
          mailbox: {},
        },
        selectableOptions: {
          domain: [],
          pkg: [],
        },
      },
    };
  },
  mounted() {
    this.filledInSaleDefinition = this.emptySaleDefinition;
  },
  methods: {
    onComplete() {
      this.$swal({
        title:
          "Add " + this.filledInSaleDefinition.requiredObjs.mailbox.username,
        text:
          "Are you sure you want to add " +
          this.filledInSaleDefinition.requiredObjs.mailbox.username +
          "?",
        type: "warning",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonText: "Add Mailbox",
      }).then((result) => {
        if (result.value) {
          this.$emit("createSale", this.filledInSaleDefinition);
        }
      });
    },
    validateStep(stepName) {
      return this.$validator.validateAll(stepName).then((result) => {
        if (result) {
          return true;
        } else {
          return false;
        }
      });
    },
  },
};
</script>